@if (!isLoading()) {
  <form [formGroup]="designForm">
    <div class="flex flex-col space-y-2">

      <div class="flex flex-col">
        <label>Name</label>
        <input class="w-full" id="name" type="string" required pInputText formControlName="name" />
        @if (designForm.controls.name.value.length > 0 && designForm.controls.name.value.length < 3) {
          <p class="validation-error">
            Must be longer than three characters
          </p>
        }
      </div>

      <p-fieldset legend="Well Type and Datums">
        <div formGroupName="wellType">
          <div class="flex flex-col mb-2">
            <label>Type</label>
            <p-select formControlName="type" [options]="wellTypes"></p-select>
          </div>

          <p-fieldset legend="Elevation">
            <div class="flex flex-col mb-2">
              <label for="drillFloorElevation">Drill Floor Elevation {{ depthRelativeTo }}</label>
              <p-inputgroup>
                <p-inputNumber (onFocus)="onInputFocus($event)" id="drillFloorElevation"
                  formControlName="drillFloorElevation" [minFractionDigits]="1"></p-inputNumber>
              </p-inputgroup>
              @if (wtc.controls.drillFloorElevation.invalid) {
                <p class="validation-error mb-2">
                  Wellhead must be below or at DFE
                </p>
              }
            </div>

            @if (wtc.controls.type.value !== 'Subsea') {
            <div class="flex flex-col mb-2">
              <label for="wellheadElevation">{{ wellheadType }} {{ wellheadElevationRelativeTo }}</label>
              <p-inputNumber (onFocus)="onInputFocus($event)" id="wellheadElevation" formControlName="wellheadElevation"
                [minFractionDigits]="1">
              </p-inputNumber>
              @if (wtc.controls.wellheadElevation.invalid) {
                <p class="validation-error">
                  {{ wellheadError }}
                </p>
              }
            </div>
            }

            @if (wtc.controls.type.value === 'Subsea') {
            <div class="flex flex-col">
              <label for="wellheadDepth">{{ wellheadType }} {{ wellheadElevationRelativeTo }}</label>
              <p-inputNumber (onFocus)="onInputFocus($event)" id="wellheadDepth" formControlName="wellheadDepth"
                [minFractionDigits]="1"></p-inputNumber>
              @if (wtc.controls.wellheadDepth.invalid) {
                <p class="validation-error">Wellhead must be above the seafloor</p>
              }
            </div>
            }

          </p-fieldset>

          @if (waterDepthVisible) {
          <p-fieldset legend="Offshore">
            <div class="flex flex-col">
              <label for="waterDepth">Water Depth ({{ lengthUnit }})</label>
              <p-inputNumber (onFocus)="onInputFocus($event)" id="waterDepth" formControlName="waterDepth"
                [minFractionDigits]="1"></p-inputNumber>
              @if (wtc.controls.waterDepth.invalid) {
                <p class="validation-error">Wellhead must be above the seafloor</p>
              }
            </div>
            <p class="text-sm">Mudline Depth: {{ mudlineDepth }} ({{ lengthUnit }})</p>
          </p-fieldset>
          }

        </div>

      </p-fieldset>

      <div class="pt-4 pb-4">
        <p-checkBox
          [binary]="true"
          (onChange)="applyDefaultWorkspaceChange()"
          inputId="defaultWorkspace"
        ></p-checkBox>
        <label for="defaultWorkspace" class="pl-2">Apply default workspace</label>
      </div>

      <p-fieldset legend="Dashboard Template" class="w-full" [hidden]="applyDefaultWorkspace">
        <div class="flex flex-col">

          <label for="designTemplate">Apply tab and component layout from another design (optional):</label>

          <p-treeSelect 
            containerStyleClass="w-full"
            [options]="config.data.treeItems" 
            appendTo="body" 
            [(ngModel)]="selectedTemplateNode"
            placeholder="Select a design" 
            filter="true" 
            filterBy="data.label" 
            showClear="true" 
            (onNodeSelect)="onTemplateSelect($event.node?.data.id)" 
            (onClear)="onTemplateClear()" 
            class="w-full"
          >
            <!-- Custom template for dropdown items -->
            <ng-template pTemplate="default" let-node>
              <span class="flex items-center gap-2">
                @if (node?.data?.level !== 'designs') {
                  <img
                    class="level-icon"
                    [src]="node?.data?.icon"
                    alt="icon"
                  />
                }
                {{ node?.data?.label }}
              </span>
            </ng-template>
            
            <!-- Custom template for the selected value -->
            <ng-template pTemplate="value" let-node>
              @if (!node) {
                <div>Select a design</div>
              }
              <div class="w-full">{{ node?.data?.label }}</div>
            </ng-template>
          </p-treeSelect>

          @if (templateWorkspaces) {
            <div>
              <br />
              <p-fieldset legend="Tabs in Selected Dashboard Template:">
                @for (tab of templateWorkspaces.workspaces; track tab.name) {
                  <div class="inline-flex">
                    <p-chip class="pl-3 pr-3 pb-1 pt-1 text-sm" [pTooltip]="showComponentList(tab.uiComponents)" [escape]="false">{{ tab.name }}</p-chip>
                  </div>
                }
              </p-fieldset>
            </div>
          }
        </div>
      </p-fieldset>

    </div>
    
    <div class="float-right">
      <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-danger" label="Cancel"
        (click)="onCancel()"></button>
      <button pButton type="button" icon="pi pi-check" class="p-button-text p-button-success"
        [disabled]="designForm.invalid" label="Save" (click)="onSave()"></button>
    </div>

  </form>
}